import { render } from "./AwardsPage.vue?vue&type=template&id=de90e00c&scoped=true"
import script from "./AwardsPage.vue?vue&type=script&lang=js"
export * from "./AwardsPage.vue?vue&type=script&lang=js"

import "./AwardsPage.vue?vue&type=style&index=0&id=de90e00c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de90e00c"]])

export default __exports__